import { EpimsBaseEntityDto } from "./epim-base.dto";

export class OilMineralLeaseDto extends EpimsBaseEntityDto {
    OilMineralName: string;
}
    